import React from 'react';
import { DRAWINGS } from '../data/sectionsData';
import ShowMoreButton from './ShowMoreButton';

const INITIAL_VISIBLE_DRAWINGS = 4;

export default function ArtSection({ expanded, onToggle, getVisibleItems, onOpenLightbox }) {
    return (
        <section className="py-16 md:py-24 px-4 md:px-6 max-w-[1200px] mx-auto" id="art">
            <div className="mb-16 reveal">
                <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-container text-on-primary-container rounded-full text-[0.8125rem] font-semibold uppercase tracking-widest mb-4">
                    <i className="fa-solid fa-palette"></i> Art
                </span>
                <h2 className="text-[clamp(1.75rem,4vw,2.75rem)] font-bold tracking-tight text-on-surface mb-2">Drawn by Hand</h2>
                <p className="text-[1.0625rem] text-on-surface-variant max-w-[560px] leading-relaxed">
                    When I step away from the keyboard, I pick up a pen or a pencil. Here's a selection of my sketches.
                </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {getVisibleItems('drawings', DRAWINGS).map((d, i) => (
                    <div
                        key={i}
                        className={`group relative rounded-2xl overflow-hidden aspect-[4/3] cursor-pointer shadow-1 hover:shadow-4 hover:scale-[1.02] transition-all duration-400 ease-emphasized reveal reveal-delay-${Math.min(i + 1, 4)}`}
                        onClick={() => onOpenLightbox({ type: 'art', title: d.title, subtitle: d.medium, imageLink: d.link })}
                    >
                        <img
                            src={d.link}
                            alt={d.title}
                            className="w-full h-full object-cover group-hover:scale-[1.08] transition-transform duration-600 ease-standard"
                            loading="lazy"
                        />
                        {/* Overlay */}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-400 ease-standard">
                            <div>
                                <h4 className="text-white font-semibold">{d.title}</h4>
                                <p className="text-white/70 text-[0.8125rem]">{d.medium}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <ShowMoreButton
                expanded={expanded}
                onClick={onToggle}
                totalCount={DRAWINGS.length}
                visibleCount={INITIAL_VISIBLE_DRAWINGS}
            />
        </section>
    );
}
